import { CSSProperties } from 'react'

type Props = {
  size?: number
  style?: CSSProperties
  className?: string
}

// Copied from apps/connect/src/components/chrome/PhillipsScrew.tsx (2026-07-16).
// No connect-only references — verbatim per-app copy.
export function PhillipsScrew({ size = 10, style, className }: Props) {
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{
        position: 'absolute',
        width: size,
        height: size,
        background: 'radial-gradient(circle at 35% 30%, #f0f3f6 0%, #c1c8d0 28%, #6b7480 60%, #2c333c 100%)',
        borderRadius: '50%',
        boxShadow:
          '0 1px 1.5px rgba(0,0,0,0.55), inset 0 -1px 1px rgba(0,0,0,0.4), inset 0 0.6px 0.6px rgba(255,255,255,0.55)',
        ...style,
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: Math.max(2, size * 0.55),
          height: 0.8,
          background: 'rgba(0,0,0,0.7)',
          transform: 'translate(-50%, -50%) rotate(40deg)',
          boxShadow: '0 0.5px 0 rgba(255,255,255,0.25)',
        }}
      />
      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: Math.max(2, size * 0.55),
          height: 0.8,
          background: 'rgba(0,0,0,0.7)',
          transform: 'translate(-50%, -50%) rotate(-50deg)',
          boxShadow: '0 0.5px 0 rgba(255,255,255,0.25)',
        }}
      />
    </span>
  )
}
